<template>
  <div class="container-dash margin-top">
    <a-spin :spinning="loadingPage">
      <a-form :form="form">
        <a-form-item label="Type Number" prop="type">
          <a-radio-group buttonStyle="solid" 
            v-decorator="[
              'tipe_tiket',
              {
                rules: [{ required: true }],
                initialValue: initialData.tipe_tiket,
              },
            ]"
          >
            <a-radio-button type="Radio" value="Bus" ref="Bus">Bus</a-radio-button>
            <a-radio-button type="Radio" value="Car" ref="Car">Car</a-radio-button>
            <a-radio-button type="Radio" value="Flight" ref="Flight">Flight</a-radio-button>
            <a-radio-button type="Radio" value="Hotel" ref="Hotel">Hotel</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="End User">
          <a-select
            :disabled="mode === 'Edit'"
            showSearch
            placeholder="Select End User"
            v-decorator="[
              'end_user',
              { rules: [{ required: true }], initialValue: initialData.end_user },
            ]"
          >
            <a-select-option v-for="item in baseData.karyawan" :key="item.tlc">
              {{ item.tlc}} - {{ item.nama }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="User Booking">
          <a-select
            :disabled="mode === 'Edit'"
            showSearch
            placeholder="Select User Booking"
            v-decorator="[
              'user_booking',
              { rules: [{ required: true }], initialValue: initialData.user_booking },
            ]"
          >
            <a-select-option v-for="item in baseData.karyawan" :key="item.tlc">
              {{ item.tlc}} - {{ item.nama }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="No Booking">
          <a-input
            :maxLength="50"
            v-decorator="[
              'no_booking',
              { rules: [{ required: true }], initialValue: initialData.no_booking },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="Description">
          <a-textarea placeholder="Write note here ... " :rows="2"
            v-decorator="['description', { initialValue: initialData.description }]" />
        </a-form-item>
        <a-row :gutter="16">
          <a-col :span="11">
            <a-form-item label="Budget Type">
              <a-radio-group
                v-decorator="[
                  'budget_type',
                  {
                    rules: [{ required: true }],
                    initialValue: initialData.budget_type,
                  },
                ]"
                ref="refbudget_type"
                button-style="solid"
              >
                <a-radio-button value="SPPD">SPPD</a-radio-button>
                <a-radio-button value="PP">PP</a-radio-button>
                <a-radio-button value="COST_CENTER">COST CENTER</a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :span="13">
            <a-form-item label="SPPD No" v-if="!$refs.refbudget_type || ($refs && $refs.refbudget_type && $refs.refbudget_type.value=='SPPD')">
              <a-select
                showSearch
                allowClear
                :not-found-content="null"
                option-filter-prop="children"
                v-decorator="['sppd_no', { rules: [{ required: true }], initialValue: initialData.sppd_no}]"
                :default-active-first-option="false"
                :filter-option="filterOption"
                @change="handlechangeSPPD"
                placeholder="Type to Search"
              >
                <a-select-option v-for="item in baseData.sppd" :key="item.id_sppd">
                  {{item.no_sppd}}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="PP No" v-if="$refs && $refs.refbudget_type && $refs.refbudget_type.value=='PP'">
              <a-select
                showSearch
                allowClear
                :not-found-content="null"
                option-filter-prop="children"
                :default-active-first-option="false"
                :filter-option="filterOption"
                @change="handlechangePP"
                v-decorator="['pp_no', { rules: [{ required: true }], initialValue: initialData.pp_no}]"
                placeholder="Type to Search"
              >
                <a-select-option v-for="item in baseData.pp" :key="item.id_pp">
                  {{item.no_pp}}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Cost Center" v-if="$refs && $refs.refbudget_type && $refs.refbudget_type.value=='COST_CENTER'">
              <a-select
                showSearch
                allowClear
                ref="refCostCenter"
                :not-found-content="null"
                option-filter-prop="children"
                :default-active-first-option="false"
                :filter-option="filterOption"
                @change="handlechangeCostCenter"
                v-decorator="['cost_center', { rules: [{ required: true }], initialValue: initialData.cost_center}]"
                placeholder="Type to Search"
              >
                <a-select-option v-for="item in baseData.cost_center" :key="item.value">
                  {{item.jns_anggaran_id}} / {{item.text}} / {{ item.nama_pekerjaan }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item label="Peruntukan" v-if="$refs && $refs.refbudget_type && $refs.refbudget_type.value=='COST_CENTER'">
          <a-select
            showSearch
            allowClear
            :not-found-content="null"
            option-filter-prop="children"
            :default-active-first-option="false"
            :filter-option="filterOption"
            @change="handlechangePeruntukan"
            v-decorator="['peruntukan', { rules: [{ required: true }], initialValue: initialData.peruntukan}]"
            placeholder="Type to Search"
          >
            <a-select-option v-for="item in peruntukan_list" :key="item.value">
              {{item.text}}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Kode Anggaran">
          <a-tree-select
            v-decorator="[
              'kode_anggaran',
              { rules: [{ required: true }], initialValue: initialData.kode_anggaran },
            ]"
            show-search
            style="width: 100%"
            :dropdown-style="{ maxWidth: '100%', maxHeight: '400px' }"
            :tree-data="treeAnggaran"
            treeNodeFilterProp="children"
            :filterTreeNode="filterTreeNode"
            placeholder="Please select"
            allow-clear
            :treeExpandedKeys="treeExpandedKeys"
            :disabled="loading.tree"
          >
            <div slot="title" slot-scope="item">
              <div class="tree-between">
                <div class="m-text-dots full">
                  <span>{{ item.texttitle }}</span>
                  <small> ({{ item.kode_anggaran }})</small>
                </div>
              </div>
            </div>
            <template slot="suffixIcon">
              <a-icon :type="loading.tree ? 'loading' : 'down'" />
            </template>
          </a-tree-select>
        </a-form-item>
        <a-form-item label="Prospect No" v-if="selectedAggaranId">
          <a-select
            showSearch
            :not-found-content="null"
            option-filter-prop="children"
            v-decorator="[
              'prospek',
              {
                rules: [{ required: true }], initialValue: initialData.prospek
              },
            ]"
            :disabled="loading_combo_prospect" 
            :loading="loading_combo_prospect"
          >
            <a-select-option
              v-for="item in listProspect"
              :key="item.id_prospek"
            >
              {{ item.no_prospek }} - {{ item.description }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item label="Type Item">
              <a-select
                :disabled="mode === 'Edit'"
                showSearch
                placeholder="Select User Booking"
                v-decorator="[
                  'tipe_item',
                  { rules: [{ required: true }], initialValue: initialData.tipe_item },
                ]"
              >
                <a-select-option key="1">Tiket</a-select-option>
                <a-select-option key="2">Jasa</a-select-option>
                <a-select-option key="3">PPN</a-select-option>
                <a-select-option key="4">PPH 23</a-select-option>
                <a-select-option key="5">Refund</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="Type Item Value">
              <a-input-number
                :min="0"
                :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'credit',
                  { rules: [{ required: true }, { validator: checkMaxValue }], initialValue: initialData.credit },
                ]"
                class="m-width-full m-text-align right"
                @keydown="(e)=>{onlyNumber(e)}"
              ></a-input-number>
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item label="Expense Date">
          <a-date-picker
            placeholder="Select Date"
            :format="getDefaultDateFormat"
            v-decorator="[
              'expense_date',
              { rules: [{ required: true }], initialValue: initialData.expense_date },
            ]"
          />
        </a-form-item>
        <a-form-item label="Is Commission?">
          <a-radio-group
            v-decorator="[
              'iscommision',
              { rules: [{ required: true }], initialValue: initialData.iscommision },
            ]"
            @change="handleOptionCommission"
            :disabled="EnCommission"
            button-style="solid"
          >
            <a-radio-button value="1"> Yes </a-radio-button>
            <a-radio-button value="0"> No </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="With Note?" :hidden="true">
          <a-radio-group
            v-decorator="[
              'without_note',
              { rules: [{ required: true }], initialValue: initialData.without_note },
            ]"
            button-style="solid"
          >
            <a-radio-button value="0"> Yes </a-radio-button>
            <a-radio-button value="1"> No </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="Upload Transaction Document">
            <a-upload
              :showUploadList="true"
              :fileList="doctransfiles"
              :beforeUpload="beforedoctransUpload"
              v-decorator="['file_upload', { valuePropName: 'doctransfiles' }]"
              :remove="handledoctransRemove"
            >
              <a-button>
                <a-icon type="upload" />&nbsp;Select File
              </a-button>
            </a-upload>
          </a-form-item>

          <a-divider class="margin-bottom-small">Option</a-divider>
          <div>
            <h4>Upload CSV File</h4>
            <p>
              If you want to import data exported from the Traveloka app!
            </p>
            <a-upload accept=".csv" :showUploadList="true" :fileList="push" :beforeUpload="beforeUpload"
              :remove="handleRemove" v-decorator="['upload', { valuePropName: 'push' }]">
              <a-button @click="resetForm()">
                <a-icon type="upload" />&nbsp;Upload File
              </a-button>
            </a-upload>
            <a-divider v-if="getScreen"></a-divider>
          </div>

      </a-form>
    </a-spin>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";

export default {
  name: "UsageTravelokaKlaim",
  props: {
    id: String,
    mode: String,
    loadingPage: Boolean,
    baseData: {},
    listProspect: {},
    collectData: {},
    treeAnggaran: {},
    treeExpandedKeys: {},
    loading_combo_prospect: Boolean,
  },
  mixins: [GlobalMethod, CurrencyFormat],
  data() {
    return {
      pageLoading: true,
      loading: {
        tree: false
      },
      assignee:[],
      peruntukan_list: [],
      doctransfiles: [],
      EnCommission: false,
      push: [],
      selectedAggaranId: null,
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getLapListUM",
    ]),
    initialData() {
      if (this.collectData.usage_edited.length === 0) {
        return {
          tipe_tiket: 'Bus',
          end_user: null,
          user_booking: null,
          no_booking: null,
          description: "",
          budget_type: 'SPPD',
          kode_anggaran: null,
          peruntukan: null,
          tipe_item: null,
          credit: null,
          iscommision: '0',
          expense_date: null,
          without_note: '0',
          prospek: null
        };
      } else {
        return {
          tipe_tiket: this.collectData.usage_edited.type_ticket || this.collectData.usage_edited.tipe_ticket,
          end_user: this.collectData.usage_edited.end_user,
          user_booking: this.collectData.usage_edited.user_booking,
          no_booking: this.collectData.usage_edited.no_booking,
          description: this.collectData.usage_edited.description,
          budget_type: this.collectData.usage_edited.sppd_no ? 'SPPD' : (this.collectData.usage_edited.pp_no ? 'PP' : 'COST_CENTER'),
          sppd_no: this.collectData.usage_edited.sppd_no ? this.collectData.usage_edited.sppd_no : null,
          pp_no: this.collectData.usage_edited.pp_no ? this.collectData.usage_edited.pp_no : null,
          cost_center: this.collectData.usage_edited.anggaran_id ? this.collectData.usage_edited.anggaran_id : null,
          kode_anggaran: this.collectData.usage_edited.anggaran_dtl_id+";"+this.collectData.usage_edited.anggaran_dtl_val_id,
          peruntukan: this.collectData.usage_edited.peruntukan_id ? this.collectData.usage_edited.peruntukan_id : null,
          tipe_item: this.collectData.usage_edited.type_item,
          credit: this.collectData.usage_edited.credit,
          iscommision: this.collectData.usage_edited.iscommision,
          expense_date: this.collectData.usage_edited.expense_date,
          without_note: this.collectData.usage_edited.without_note,
          prospek: this.collectData.usage_edited.prospek
        };
      }
    },
  },
  methods: {
    moment,
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handlechangeCostCenter(val){
      if(val) this.evaluateProspect(val); else this.selectedAggaranId = null;
      this.form.setFieldsValue({
        peruntukan: undefined,
        kode_anggaran: undefined
      });

    },
    handlechangeSPPD(val){
      if(val){
        const exactSPPD = _.filter(this.baseData.sppd, item=>item.id_sppd==val)
        this.evaluateProspect(exactSPPD[0].anggaran_id)
      }else{
        this.selectedAggaranId = null
      }
      const origin_ = {
        sppd_no: val
      }
      this.$nextTick(function () {
        this.form.setFieldsValue({
          kode_anggaran: undefined
        });
      });

      Event.$emit("treeAggTraveloka", origin_);
    },
    handlechangePP(val){
      if(val){
        const exactPP = _.filter(this.baseData.pp, item=>item.id_pp==val)
        this.evaluateProspect(exactPP[0].anggaran_id)
      }else{
        this.selectedAggaranId = null
      }
      const origin_ = {
        pp_no: val
      }
      this.$nextTick(function () {
        this.form.setFieldsValue({
          kode_anggaran: undefined
        });
      });

      Event.$emit("treeAggTraveloka", origin_);
    },
    handlechangePeruntukan(val){
      const vinput = this.form.getFieldsValue();
      
      const origin_ = {
        anggaran_id: vinput.cost_center,
        peruntukan_id: val
      }
      this.$nextTick(function () {
        this.form.setFieldsValue({
          kode_anggaran: undefined
        });
      });

      Event.$emit("treeAggTraveloka", origin_);
    },
    handlechangePeruntukan_modeEdit(item){
      const origin_ = {
        anggaran_id: item.anggaran_id,
        peruntukan_id: item.peruntukan_id
      }
      this.$nextTick(function () {
        this.form.setFieldsValue({
          kode_anggaran: item.anggaran_dtl_id+";"+item.anggaran_dtl_val_id,
        });
      });

      Event.$emit("treeAggTraveloka", origin_);
    },
    filterTreeNode(input, option) {
      return (
        option.data.props.texttitle == undefined ||
        (option.data.props.texttitle ? option.data.props.texttitle : "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0 ||
        (option.data.props.kode_anggaran ? option.data.props.kode_anggaran : "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    checkMaxValue(rule, value, callback) {
      if (value <= 9999999999999) {
        callback();
        return;
      }
      callback("Max. value 9.999.999.999.999!");
    },
    beforedoctransUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 10) {
        this.displayMessage("large-file-10mb");
      } else {
        this.doctransfiles = [file];
        return false;
      }
    },
    handledoctransRemove() {
      this.doctransfiles = [];
    },
    handleOptionCommission(){
    // handleOptionCommission(val){
      // if(val.target.value=="1"){
      //   this.Viwithout_note = false;
      // }else{
      //   this.Viwithout_note = true;
      // }
      // this.$nextTick(function () {
      //   this.formCollective.setFieldsValue({
      //       without_note: "0",
      //   });
      // });
    },
    setloadingTree(value){
      this.loading.tree = value
    },
    resetForm(){
      this.form.resetFields();
      this.doctransfiles = [];
      this.selectedAggaranId = null;
    },
    handleRef(){
      this.form.validateFields((err, val) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        let formData = new FormData();
        if(this.id){
          if(this.collectData.usage_edited.length === 0){
            formData.append("id_laporan", this.id);
          }else{
            formData.append("id", this.collectData.usage_edited.id);
          }
        }
        formData.append("id_user_cc", this.collectData.information.id_user_cc);
        formData.append("report_date", moment(this.collectData.information.report_date).format(this.getStandartFormatDate));
        formData.append("tipe_tiket", val.tipe_tiket);
        formData.append("end_user", val.end_user);
        const enduser_ = _.filter(this.baseData.karyawan, item=>item.tlc==val.end_user)
        formData.append("end_user_name", enduser_[0].nama);
        formData.append("user_booking", val.user_booking);
        formData.append("no_booking", val.no_booking);
        formData.append("description", val.description ? val.description : '');
        if(val.budget_type=='SPPD') formData.append("sppd_no", val.sppd_no);
        if(val.budget_type=='PP') formData.append("pp_no", val.pp_no);
        if(val.budget_type=='COST_CENTER') formData.append("cost_center", val.cost_center);
        if(val.kode_anggaran){
          const kdaggr = val.kode_anggaran.split(';');
          formData.append("kode_anggaran", kdaggr[kdaggr.length-1]);
        }
        if(val.prospek) formData.append("prospek", val.prospek);
        formData.append("tipe_item", val.tipe_item);
        formData.append("credit", val.credit);
        formData.append("expense_date", moment(val.expense_date).format(this.getStandartFormatDate));
        formData.append("iscommision", val.iscommision);
        formData.append("without_note", val.without_note);
        formData.append("note", val.note ? val.note : '');
        if(this.doctransfiles.length>0) formData.append("file_upload", this.doctransfiles[0]);
        
        Event.$emit(this.collectData.usage_edited.length === 0 ? "addDtlTraveloka" : "changeDtlTraveloka", formData);
      })
    },
    handlingBinaryFiles(item){
      if(item.lampiran_path){
        this.asyncAxiosGet("main/base_64", this.getAuth, {
          path: item.lampiran_path,
        })
        .then((response) => {
          let typefile = this.fileTypeFromUrl(item.lampiran);
          let file = this.dataURLtoFile(
            typefile + response.file_document_tax,
            item.lampiran
          );
          file.uid = "vc-upload-1-1";
          file.status = "done";
          file.url = this.$serviceUrl + item.lampiran_path;
          this.doctransfiles = [];
          this.doctransfiles.push(file);
        })
          .catch((err) => {
          console.log(err);
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
      }
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      let extension =
        file.name.substr(file.name.lastIndexOf(".")) == ".csv"
      if (extension) {
        if (FileSize > 5) {
          this.displayMessage("large-file-5mb");
        } else {
          
          let formData = new FormData();
          if(this.id) formData.append("id_laporan",this.id);
          formData.append("id_user_cc",this.collectData.information.id_user_cc);
          formData.append("report_date",moment(this.collectData.information.report_date).format(this.getStandartFormatDate));
          if(this.collectData.approval.note) formData.append("note",this.collectData.approval.note);
          formData.append("file_upload", file);
          
          this.form.resetFields();
          Event.$emit("stsuploadTravelokaFiles", true);
          this.asyncAxiosPost("klaim_tiket/upload_csv", "formdata", this.getAuth, formData)
          .then((response) => {
            Event.$emit("handleUploadCsv", response.id_laporan);
            Event.$emit("stsuploadTravelokaFiles", false);
            this.displayMessageValue("success-other", 'Import CSV is Successfully!');
          })


          this.push = [];
          return false;
        }
      } else {
        this.displayMessage("error-formatXls");
      }
    },
    handleRemove() {
      this.push = [];
    },
    evaluateProspect(val){
      this.peruntukan_list = val ? _.filter(this.baseData.peruntukan, item=>item.anggaran_id==val) : [];

      const ls_dt = _.filter(this.baseData.cost_center, item=>item.value == val);
      this.selectedAggaranId = ls_dt.length > 0 ? (ls_dt[0].jns_anggaran_id=='07' ? '07' : null) : null;
      if(this.selectedAggaranId) Event.$emit("getProspectList", {anggaran_id: val});
    }
  }
}
</script>